var mshopProductPage = (function()
{
    /**
    * 
    */
    var _configuration;
    var _selectedProductId;
    var _fancyBoxOptions;
    var _fancyBoxSlides;
    var _swiper = null;
    var _isDesktop;
    var _currentReviewsPage;
    var _loadedReviews;
    var _isLoadingMoreReviews;
    var _isSavingReview;
	var _isSavingStockReminder;
	var _isSubmittingFlashSaleForm;

    /**
     *
     */
	var $_addToCartArea;
	var $_addToCartFormProduct;
	var $_addToCartAdwordsProduct;
	var $_imageGallery;
	var $_loadMoreReviewsBar;
	var $_loadMoreReviewsButton;
	var $_loadMoreReviewsHint;
	var $_loadMoreReviewsProgress;
	var $_mainImage;
	var $_outOfStockReminder;
	var $_outOfStockReminderButton;
	var $_outOfStockReminderEmail;
	var $_outOfStockReminderForm;
	var $_outOfStockReminderMessage;
	var $_productFreight;
	var $_productPrice;
	var $_productRating;
	var $_productStock;
	var $_reviews;
	var $_selectedVariantName;
	var $_thumbnails;
	var $_variants;
	var $_writeReviewCallout;
	var $_writeReviewFormBody;
	var $_writeReviewFormBodyContainer;
	var $_writeReviewFormBodyMessage;
	var $_writeReviewFormBodyShadow;
	var $_writeReviewFormButton;
	var $_writeReviewFormMessage;
	var $_writeReviewFormName;
	var $_writeReviewFormNameContainer;
	var $_writeReviewFormNameMessage;
	var $_writeReviewFormRating;
	var $_writeReviewFormTitle;
	var $_writeReviewFormTitleContainer;
	var $_writeReviewFormTitleMessage;
    var $_accordionReviewsInput;
    var $_accordionShippingInput;
    var $_writeReviewArea;
    var $_writeReviewButton;
    var $_writeReviewForm;
	var $_freeFreightLine;
	var $_regularFreightLine;
	var $_salesHint;

	// Flash Sale
	var $_flashSaleHintArea;
	var $_flashSaleHint;
	var $_flashSaleHintHead;
	var $_flashSaleHintForm;
	var $_flashSaleHintFormMessage;
	var $_flashSaleHintSuccessMessage;
	var $_flashSaleHintFormButton;
	var $_flashSaleHintFormInput;
	var $_flashSaleHintTitle;
	var $_flashSaleHintDescription;
	var $_flashSaleAddToCartHash;

    /**
    * Executed one page is loaded
    */
    function boot()
    {
		_isDesktop = XmxApp.isDesktop(); 
        _configuration = window.naeProductConfiguration;
    	_selectedProductId = _configuration.selectedProductId;
    	_currentReviewsPage = 1;
    	_loadedReviews = Math.min(_configuration.reviewSummary.totalReviews, _configuration.reviewSummary.pageSize);
    	_isLoadingMoreReviews = false;
    	_isSavingReview = false;
		_isSavingStockReminder = false;
		_isSubmittingFlashSaleForm = false;

        // Settings for the fancy box
        _fancyBoxOptions =
        {
            loop: true,

            // 1/5 and previous/next buttons on top
            infobar: true, 

            // buttons in the top right corner
            buttons: true, 

            // What buttons should appear in the toolbar
            slideShow: true,
            fullScreen: true,
            thumbs: true,
            closeBtn: true,

            // Enable gestures (tap, zoom, pan and pinch)
            touch: true,

            // Enable keyboard navigation
            keyboard: true,

            // Try to focus on first focusable element after opening
            focus: true,

            // Close when clicked outside of the content
            closeClickOutside: true
        };

        // Hook the add to cart button
		//$_addToCartButton = jQuery('#add-to-cart-button');
		$_addToCartArea = jQuery('#add-to-cart-area');
		$_addToCartFormProduct = jQuery('#add-to-cart-form-product');
		$_addToCartAdwordsProduct = jQuery('#add-to-cart-form-adwords-product');

		// Freight cost in shipping tab
		$_freeFreightLine = jQuery('#free-freigt-line');
		$_regularFreightLine = jQuery('#regular-freight-line');

		// Hook out of stock area
		$_outOfStockReminder = jQuery('#out-of-stock-reminder');
		$_outOfStockReminderForm = jQuery('#out-of-stock-reminder-form');
		$_outOfStockReminderForm.on('submit', onOutOfStockFormSubmit);
		$_outOfStockReminderButton = jQuery('#out-of-stock-reminder-button');
		$_outOfStockReminderEmail = jQuery('#out-of-stock-reminder-email');
		$_outOfStockReminderMessage = jQuery('#out-of-stock-reminder-message');

    	// Make the star rating header clickable
    	$_accordionReviewsInput = jQuery('#accordion-reviews');
		$_productRating = jQuery('#product-rating');
		$_productRating.on('click', onProductRatingClick);

    	// Make the freight clickable
    	$_accordionShippingInput = jQuery('#accordion-shipping');
		$_productFreight = jQuery('#product-freight');
		$_productFreight.on('click', onProductFreightClick);

		// Make the variants clickable
		$_variants = jQuery('#product-variants > .xmx-product-variation');
		$_variants.on('click', onVariantClick);

		// Hook the variant name
		$_selectedVariantName = jQuery('#selected-variant-name');

		// Hook the stock
		$_productStock = jQuery('#product-stock');

		// Hook the price
		$_productPrice = jQuery('#product-price');

		// Hook the thumbnails and main image
		$_thumbnails = jQuery('#thumbnails');
		$_mainImage = jQuery('#main-image');
		$_imageGallery = jQuery('#image-gallery');

		// Hook the review area
		$_reviews = jQuery('#reviews');
		$_loadMoreReviewsHint = jQuery('#load-more-reviews-hint');
		$_loadMoreReviewsBar = jQuery('#load-more-reviews-bar');
		$_loadMoreReviewsProgress = jQuery('#load-more-reviews-progress');
		$_loadMoreReviewsButton = jQuery('#load-more-reviews-button');
		$_loadMoreReviewsButton.on('click', onLoadMoreReviewsButtonClick);

        // Make the "Write Review" button clickable
        $_writeReviewArea = jQuery('#write-review-area');
        $_writeReviewCallout = jQuery('#write-review-callout');
        $_writeReviewButton = jQuery('#write-review-button');
        $_writeReviewButton.on('click', onWriteReviewButtonClick);
        $_writeReviewFormButton = jQuery('#write-review-form-button');
        $_writeReviewForm = jQuery('#write-review-form');
    	$_writeReviewForm.on('submit', onWriteReviewFormSubmit);

    	// Review Form Star Rating
		$_writeReviewFormRating = jQuery('#write-review-form-rating');

		// Review Form Name Input
		$_writeReviewFormName = jQuery('#write-review-form-name');
		$_writeReviewFormName.on('paste', onWriteReviewFormNameInteraction);
		$_writeReviewFormName.on('keyup', onWriteReviewFormNameInteraction);
		$_writeReviewFormName.on('keydown', onWriteReviewFormNameInteraction);
		$_writeReviewFormName.on('blur', onWriteReviewFormNameInteraction);

		// Review Form Title Input
		$_writeReviewFormTitle = jQuery('#write-review-form-title');
		$_writeReviewFormTitle.on('paste', onWriteReviewFormTitleInteraction);
		$_writeReviewFormTitle.on('keyup', onWriteReviewFormTitleInteraction);
		$_writeReviewFormTitle.on('keydown', onWriteReviewFormTitleInteraction);
		$_writeReviewFormTitle.on('blur', onWriteReviewFormTitleInteraction);

		// Review Form Body Text Area
		$_writeReviewFormBodyShadow = jQuery('#write-review-form-body-shadow');
		$_writeReviewFormBody = jQuery('#write-review-form-body');
		$_writeReviewFormBody.on('paste', onWriteReviewFormBodyInteraction);
		$_writeReviewFormBody.on('keyup', onWriteReviewFormBodyInteraction);
		$_writeReviewFormBody.on('keydown', onWriteReviewFormBodyInteraction);
		$_writeReviewFormBody.on('blur', onWriteReviewFormBodyInteraction);

		// Validation messages
		$_writeReviewFormNameMessage = $_writeReviewFormName.parent().next();
		$_writeReviewFormTitleMessage = $_writeReviewFormTitle.parent().next();
		$_writeReviewFormBodyMessage = $_writeReviewFormBody.parent().next();

		// Input field wraps
		$_writeReviewFormNameContainer = $_writeReviewFormName.parent().parent();
		$_writeReviewFormTitleContainer = $_writeReviewFormTitle.parent().parent();
		$_writeReviewFormBodyContainer = $_writeReviewFormBody.parent().parent();

		// Success message
		$_writeReviewFormMessage = jQuery('#write-review-form-message');

		// Flash Sale
		$_flashSaleHintArea = jQuery('#xmx-flash-sale-hint-area');
		$_flashSaleHint = jQuery('#xmx-flash-sale-hint');
		$_flashSaleHintHead = jQuery('#xmx-flash-sale-hint-head');
		$_flashSaleHintHead.on('click', onFlashSaleHintHeadClick);
		$_flashSaleHintForm = jQuery('#xmx-flash-sale-hint-form');
		$_flashSaleHintForm.on('submit', onFlashSaleHintFormSubmit);
		$_flashSaleHintFormMessage = jQuery('#xmx-flash-sale-hint-form-message');
		$_flashSaleHintSuccessMessage = jQuery('#xmx-flash-sale-hint-success-message');
		$_flashSaleHintFormButton = jQuery('#xmx-flash-sale-hint-form-button');
		$_flashSaleHintFormInput = jQuery('#xmx-flash-sale-hint-form-input');
		$_flashSaleHintTitle = jQuery('#xmx-flash-sale-hint-title');
		$_flashSaleHintDescription = jQuery('#xmx-flash-sale-hint-description');
		$_flashSaleAddToCartHash = jQuery('#add-to-cart-form-flash');

		// Qty. sold
		$_salesHint = jQuery('#product-sales');

        // Start the gallery
        updateGallery();

		sendStockAlerts();
		
		// If the visitor is coming from Google Adwords, update the price
		if (XmxApp.isComingFromGoogleAdwords())
		{
			updatePrice();
		}

		// Update flash sale hint
		updateFlashSaleHint();

		// Update sales int
		updateSalesHint();
    }

	/**
	 * User has clicked flash sale head
	 */
	function onFlashSaleHintHeadClick()
	{
		$_flashSaleHint.toggleClass('xmx-flash-sale-hint--open');
	}

	/**
	 * User has submitted flash sale form
	 * 
	 * @param {event} event 
	 */
	function onFlashSaleHintFormSubmit(event)
	{
		var email;
		var validationMessage;
		var hash;

		// Do not submit twice
		if (!_isSubmittingFlashSaleForm)
		{
			// Check that the email address is not empty
			email = $_flashSaleHintFormInput.val().toLowerCase().trim();
			validationMessage = XmxApp.validateEmailAddress(email);

			if (validationMessage != '')
			{
				// Validation failed
				$_flashSaleHintFormMessage.html(validationMessage);
				$_flashSaleHintFormMessage.addClass('xmx-flash-sale-hint-form-message--visible');
			}
			else 
			{
				hash = XmxApp.generateHashCode(email);

				// Block clicking twice
				_isSubmittingFlashSaleForm = true;

				// Validation passed
				$_flashSaleHintFormMessage.removeClass('xmx-flash-sale-hint-form-message--visible');
				$_flashSaleHintFormMessage.html('');

				// Show the ajax loader
				$_flashSaleHintFormInput.attr('disabled', true);
				$_flashSaleHintFormButton.attr('disabled', true);

				// Tell the server
				// Post the data
				jQuery.ajax
				({
					url: '/ajax/product/flashsale',
					dataType: 'json',
					type: 'post',
					data:
					{
						'productId': _selectedProductId,
						'storeId': _configuration.storeId,
						'email': email,
						'hash': hash
					},
					success: function (response)
					{
						if (response.success)
						{
							// Reset the form
							$_flashSaleHintFormInput.val('');

							// Update the price visible for the user
							updateFlashSalePrice();

							// Tell the add to cart form, it is a flash sale

							// Hide the hint
							$_flashSaleHint.hide();

							// Show the success message
							$_flashSaleHintSuccessMessage.addClass('xmx-message--visible');

							// Update the add to cart form, so that the flash sale price is 
							// whenever the user adds it to the cart
							$_flashSaleAddToCartHash.val(response.cartHash);
						}
					},
					complete: function ()
					{
						// We are not saving anymore
						_isSubmittingFlashSaleForm = false;

						// Remove loading bubbles
						$_flashSaleHintFormInput.attr('disabled', false);
						$_flashSaleHintFormButton.attr('disabled', false);
					}
				});
			}
		}

		// Always cancel the event
		event.stopPropagation();
		event.preventDefault();

		return false;
	}

	/**
	 * 
	 */
	function updateSalesHint()
	{
		// If there is no sales info, get out of here
		if (_configuration.sales === null)
		{
			return;
		}

		var elapsedHours = (XmxApp.getCurrentTimestamp() - _configuration.sales.time) / (60 * 60);
		var quantitySold = Math.floor(_configuration.sales.quantity + _configuration.sales.speed * elapsedHours);
		var hint = _configuration.translations.salesInfo.replace('$1', quantitySold);

		$_salesHint.html(hint);
		$_salesHint.show();
	}

	/**
	 * 
	 */
	function updateFlashSaleHint()
	{
		var productData = _configuration.productData[_selectedProductId];
		var now = XmxApp.getCurrentTimestamp();
		var showFlashSaleHint = false;

		if (productData.flashSalePrice > 0)
		{
			if (now >= productData.flashSaleStart)
			{
				if (now <= productData.flashSaleEnd)
				{
					showFlashSaleHint = true;
				}
			}
		}

		if (!showFlashSaleHint)
		{
			$_flashSaleHintArea.hide();
		}
		else 
		{
			// Update title and description
			var title = '';
			var description = '';

			switch (productData.flashSaleMode)
			{
				// Save an additional X%
				case 'percent-discount':
				{
					title = _configuration.translations.flashSaleTitlePercentDiscount;
					break;
				}

				// Save an additional X kr
				case 'amount-discount':
				{
					title = _configuration.translations.flashSaleTitleAmountDiscount;
					break;
				}

				// Get for it for X kr
				case 'fixed-price':
				{
					title = _configuration.translations.flashSaleTitleFixedPrice;
					break;
				}
			}

			// Replace placeholders
			var savingPercent = 100 - Math.round(productData.flashSalePrice * 100 / productData.finalPrice);
			var savingAmount = productData.finalPrice - productData.flashSalePrice;

			var savingPercentString = savingPercent + '%';
			var savingAmountString = XmxApp.formatAmount(savingAmount);
			var priceAmountString = XmxApp.formatAmount(productData.flashSalePrice);

			title = title.replace('$1', savingPercentString);
			title = title.replace('$2', savingAmountString);
			title = title.replace('$3', priceAmountString);

			description = _configuration.translations.flashSaleDescription;
			description = description.replace('$1', savingPercentString);
			description = description.replace('$2', savingAmountString);
			description = description.replace('$3', priceAmountString);

			// Update elements
			$_flashSaleAddToCartHash.val('');
			$_flashSaleHintFormMessage.removeClass('xmx-flash-sale-hint-form-message--visible');
			$_flashSaleHintFormMessage.html('');
			$_flashSaleHintSuccessMessage.removeClass('xmx-message--visible');
			$_flashSaleHintDescription.html(description);
			$_flashSaleHintTitle.html(title);
			$_flashSaleHintArea.show();
			$_flashSaleHint.show();
		}
	}

	/**
	 * Updates the price UI
	 */
	function updateFlashSalePrice()
	{
		var productData = _configuration.productData[_selectedProductId];
		var $line1;
		var $line2;
		var $freight;
		var $freightCaption;
		var $oldPrice;
		var $saving;
		var $price;
		var saving;
		var discountInfo;

		// Calculate saving %
		saving = 100 - Math.round(productData.flashSalePrice * 100 / productData.price);
		discountInfo = _configuration.translations.save + ' ' + saving + '%';

		// Throw away the old info
		$_productPrice.empty();

		// Add line 1
		$line1 = jQuery('<div>');
		$line1.addClass('xmx-product-detail-price-line-1');
		$line1.appendTo($_productPrice);

		// Add line 2
		$line2 = jQuery('<div>');
		$line2.addClass('xmx-product-detail-price-line-2');
		$line2.appendTo($_productPrice);

		$oldPrice = jQuery('<div>');
		$oldPrice.addClass('xmx-product-detail-price-old');
		$oldPrice.html(XmxApp.formatPrice(productData.price));
		$oldPrice.appendTo($line1);

		$saving = jQuery('<div>');
		$saving.addClass('xmx-product-detail-price-saving');
		$saving.html(discountInfo);
		$saving.appendTo($line1);

		// Build the price
		$price = jQuery('<div>');
		$price.addClass('xmx-product-detail-price-special');
		$price.html(XmxApp.formatPrice(productData.flashSalePrice));
		$price.appendTo($line2);

		// Build shipping
		$freight = jQuery('<div>');
		$freight.addClass('xmx-product-detail-price-freight');
		$freight.attr('id', 'product-freight');
		$freight.attr('title', _configuration.translations.readMoreAboutShipping);
		$freight.appendTo($line2);

		// Re-hook it
		$_productFreight = $freight;
		$_productFreight.on('click', onProductFreightClick);

		// Caption the freight
		$freightCaption = jQuery('<span>');
		$freightCaption.addClass('xmx-product-detail-price-freight-inner');

		if (productData.flashSalePrice >= _configuration.shipping.freeAt)
		{
			$freightCaption.html(_configuration.translations.freeShipping);

			// Update price in shipping tab
			$_freeFreightLine.show();
			$_regularFreightLine.hide();
		}
		else 
		{
			$freightCaption.html(_configuration.translations.shipsForX.replace('%1', XmxApp.formatAmount(_configuration.shipping.fee)));

			// Update price in shipping tab
			$_freeFreightLine.hide();
			$_regularFreightLine.show();
		}

		$freightCaption.appendTo($freight);
	}

    /**
     * Sends an alert if the visitor comes from Google Adwords and sees an out of stock
     * product.
     */
    function sendStockAlerts()
    {
    	var googleClickId;

    	if (_configuration.isCompletelyOutOfStock)
    	{
    		// Google Adwords
    		googleClickId = XmxApp.extractHttpGetParameter('gclid');

    		if (googleClickId != '')
    		{
				jQuery.ajax
				({
					url: '/ajax/product/googleAdwordsAlert',
					dataType: 'json',
					type: 'post',
					data:
					{
						'productId': _selectedProductId,
						'storeId': _configuration.storeId,
						'url': window.location.href,
						'clickId': googleClickId
					}
				});
    		}

    		// Google Analytics
			if (typeof ga !== 'undefined')
			{
				ga('send', 'event', 
				{
					'eventCategory': 'Out of Stock Product View',
					'eventAction': _configuration.productData[_selectedProductId].sku,
					'eventLabel': googleClickId, 
					'nonInteraction': true
				});
			}
    	}
    }

    /**
     * A user is submitting the "please send me an email once its back" form
     */
    function onOutOfStockFormSubmit()
    {
    	var email = $_outOfStockReminderEmail.val().trim();

    	// No realy validation for now
    	if (email == '')
    	{
    		return false;
    	}

    	// If we are already saving things, get out of here
    	if (_isSavingStockReminder)
    	{
    		return false;
    	}

    	_isSavingStockReminder = true;

    	// Disable the button and show the loading bubbles
    	$_outOfStockReminderButton.attr('disabled', true);
    	$_outOfStockReminderButton.addClass('xmx-button--loading');

    	// Post the data
		jQuery.ajax
		({
			url: '/ajax/product/postStockReminder',
			dataType: 'json',
			type: 'post',
			data:
			{
				'productId': _selectedProductId,
				'storeId': _configuration.storeId,
				'email': email
				// TODO: checksum
			},
			success: function(response)
			{
				if (response.success)
				{
					// Reset the form
					$_outOfStockReminderEmail.val('');

					// Hide the form
					$_outOfStockReminderForm.hide();

					// Show the message
					$_outOfStockReminderMessage.addClass('xmx-message--visible');
				}
			},
			complete: function()
			{
				// We are not saving anymore
				_isSavingStockReminder = false;

				// Disable the button and hide the loading bubbles
				$_outOfStockReminderButton.attr('disabled', false);
				$_outOfStockReminderButton.removeClass('xmx-button--loading');
			}
		});

    	return false;
    }

    /**
     * The user has submittedthe "Post Review" form
     *
     * This solution is not elegant, but does the job for now
     */
    function onWriteReviewFormSubmit()
    {
    	var rating;
    	var name;
    	var title;
    	var body;
    	var hasValidationErrors = false;
    	var minimumBodyLength = $_writeReviewFormBody.data('cool-length');

    	// The rating is always present, since its a star rating
    	rating = $_writeReviewFormRating.val();

    	// Check that the name is present
		name = $_writeReviewFormName.val().trim();

		if (name == '')
		{
			$_writeReviewFormNameMessage.html(_configuration.translations.pleaseEnterAName);
			$_writeReviewFormNameContainer.addClass('xmx-form-field--error');
			$_writeReviewFormNameContainer.addClass('xmx-form-field--show-message');
			hasValidationErrors = true;
		}
		else 
		{
			$_writeReviewFormNameContainer.removeClass('xmx-form-field--error');
			$_writeReviewFormNameContainer.removeClass('xmx-form-field--show-message');
		}

		// Check that the title is present
		title = $_writeReviewFormTitle.val().trim();

		if (title == '')
		{
			$_writeReviewFormTitleMessage.html(_configuration.translations.pleaseEnterATitle);
			$_writeReviewFormTitleContainer.addClass('xmx-form-field--error');
			$_writeReviewFormTitleContainer.addClass('xmx-form-field--show-message');
			hasValidationErrors = true;
		}
		else 
		{
			$_writeReviewFormTitleContainer.removeClass('xmx-form-field--error');
			$_writeReviewFormTitleContainer.removeClass('xmx-form-field--show-message');
		}

		// Check that the body is present
		body = $_writeReviewFormBody.val().trim();

		if (body == '')
		{
			$_writeReviewFormBodyMessage.html(_configuration.translations.pleaseEnterABody);
			$_writeReviewFormBodyContainer.addClass('xmx-form-field--error');
			$_writeReviewFormBodyContainer.addClass('xmx-form-field--show-message');
			hasValidationErrors = true;
		}
		else 
		{
			// Check that the body is of minimum length
			if (body.length < minimumBodyLength)
			{
				$_writeReviewFormBodyMessage.html(_configuration.translations.pleaseEnterALongerBody);
				$_writeReviewFormBodyContainer.addClass('xmx-form-field--error');
				$_writeReviewFormBodyContainer.addClass('xmx-form-field--show-message');
				hasValidationErrors = true;
			}
			else 
			{
				$_writeReviewFormBodyContainer.removeClass('xmx-form-field--error');
				$_writeReviewFormBodyContainer.removeClass('xmx-form-field--show-message');
			}
		}

		// If we have validation errors, get the hell out of here
		if (hasValidationErrors)
		{
			return false;
		}

    	// If we are already saving the review, abort
    	if (_isSavingReview)
    	{
			return false;
    	}

    	// Remember that we are saving the review
    	_isSavingReview = true;

    	// Disable the button and show the loading bubbles
    	$_writeReviewFormButton.attr('disabled', true);
    	$_writeReviewFormButton.addClass('xmx-button--loading');

    	// Get some new reviews
		jQuery.ajax
		({
			url: '/ajax/product/postReview',
			dataType: 'json',
			type: 'post',
			data:
			{
				'productId': _configuration.productId,
				'storeId': _configuration.storeId,
				'rating': rating,
				'name': name,
				'title': title,
				'body': body
			},
			success: function(response)
			{
				if (response.success)
				{
					// Reset the form
					$_writeReviewFormRating.val(5);
					$_writeReviewFormName.val('');
					$_writeReviewFormTitle.val('');
					$_writeReviewFormBody.val('');

					// And disable it
					$_writeReviewFormRating.attr('disabled', true);
					$_writeReviewFormName.attr('disabled', true);
					$_writeReviewFormTitle.attr('disabled', true);
					$_writeReviewFormBody.attr('disabled', true);

					// Show the message
					$_writeReviewFormButton.hide();
					$_writeReviewFormMessage.show();
				}
			},
			complete: function()
			{
				// We are not saving anymore
				_isSavingReview = false;

				// Disable the button and hide the loading bubbles
				$_writeReviewFormButton.attr('disabled', false);
				$_writeReviewFormButton.removeClass('xmx-button--loading');
			}
		});

		return false;
    }

    /** 
     * Called after the user has done something with the review form name
     */
    function onWriteReviewFormNameInteraction()
    {
    	// Update the length indicator
    	updateInputFieldLengthIndicator($_writeReviewFormName);

    	// Remove the error message
		$_writeReviewFormNameContainer.removeClass('xmx-form-field--error');
		$_writeReviewFormNameContainer.removeClass('xmx-form-field--show-message');
    }

    /** 
     * Called after the user has done something with the review form title
     */
    function onWriteReviewFormTitleInteraction()
    {
    	// Update the length indicator
    	updateInputFieldLengthIndicator($_writeReviewFormTitle);

    	// Remove the error message
		$_writeReviewFormTitleContainer.removeClass('xmx-form-field--error');
		$_writeReviewFormTitleContainer.removeClass('xmx-form-field--show-message');
    }

    /** 
     * Called after the user has done something with the review form title
     */
    function onWriteReviewFormBodyInteraction()
    {
    	// Update the length indicator
    	updateTextareaLengthIndicator($_writeReviewFormBody);
    	updateReviewFormTextareaSize();

    	// Remove the error message
		$_writeReviewFormBodyContainer.removeClass('xmx-form-field--error');
		$_writeReviewFormBodyContainer.removeClass('xmx-form-field--show-message');
    }

    /**
     * Updates the size of the review form body. The same "could" be done
     * with the contenteditable="true", but nah..
     */
    function updateReviewFormTextareaSize()
    {
    	var content;
    	var height;

    	// Get the content from the text area
    	content = $_writeReviewFormBody.val();

    	// Replace all line breaks
    	content = content.replace(/\n/g, '<br>');

    	// Add one more character, as the last line break at the 
    	// end of the string does not seem to count
    	content += '<br>a';

    	// Copy over the content from the text area to the shadow
    	$_writeReviewFormBodyShadow.html(content);

    	// Measure the height of the shadow
    	height = $_writeReviewFormBodyShadow.outerHeight();

    	// And set the height of the text area
    	$_writeReviewFormBody.css('height', height + 'px');
    }

	/**
	 * Updates the length indicator of an input field
	 */
	function updateTextareaLengthIndicator($textarea)
	{
		var coolLength = $textarea.data('cool-length');
		var awesomeLength = $textarea.data('awesome-length');
		var rockstarLength = $textarea.data('rockstar-length');
		var length = $textarea.val().trim().length;
		var $indicator = $textarea.next();

		if (length >= rockstarLength)
		{
			$indicator.html(_configuration.translations.reviewRockstarLength + ' (' + length + ' / ' + coolLength + ')');
		}
		else 
		{
			if (length >= awesomeLength)
			{
				$indicator.html(_configuration.translations.reviewAwesomeLength + ' (' + length + ' / ' + coolLength + ')');
			}
			else 
			{
				if (length >= coolLength)
				{
					$indicator.html(_configuration.translations.reviewCoolLength + ' (' + length + ' / ' + coolLength + ')');
				}
				else 
				{
					$indicator.html(_configuration.translations.reviewMinLength + ' (' + length + ' / ' + coolLength + ')');
				}
			}
		}
	}

	/**
	 * Updates the length indicator of an input field
	 */
	function updateInputFieldLengthIndicator($inputField)
	{
		var maxLength = $inputField.attr('maxlength');
		var length = $inputField.val().trim().length;
		var $indicator = $inputField.next();

		$indicator.html(length + ' / ' + maxLength);
	}

    /**
     * The user has clicked the "Load More Reviews" button
     */
    function onLoadMoreReviewsButtonClick()
    {
    	// Do not load twice
    	if (_isLoadingMoreReviews)
    	{
    		return;
    	}

    	// Remember we are loading
    	_isLoadingMoreReviews = true;

    	// Disable the button and show the loading bubbles
    	$_loadMoreReviewsButton.attr('disabled', true);
    	$_loadMoreReviewsButton.addClass('xmx-button--loading');

    	// Get some new reviews
		jQuery.ajax
		({
			url: '/ajax/product/loadReviews',
			dataType: 'json',
			type: 'post',
			data:
			{
				'productId': _configuration.productId,
				'storeId': _configuration.storeId,
				'page': _currentReviewsPage + 1
			},
			success: function(response)
			{
				var loadedPercent;

				if (response.success)
				{
					// Add the reviews HTML
					addReviews(response.reviews);

					// Update the pagination
					_loadedReviews += response.reviews.length;
					_currentReviewsPage++;

					// If we have loaded all reviews, hide the "load more" area
					if (_loadedReviews >= _configuration.reviewSummary.totalReviews)
					{
						// Hide the progress bar
						$_loadMoreReviewsProgress.hide();

						// "No more reviews to load"
						$_loadMoreReviewsHint.html(_configuration.translations.noMoreReviewsToLoad);

						// Hide le button
						$_loadMoreReviewsButton.hide();
					}
					else 
					{
						// Calculate the %
						loadedPercent = _loadedReviews * 100 / _configuration.reviewSummary.totalReviews;

						// Update the progress bar
						$_loadMoreReviewsBar.css('width', loadedPercent + '%');

						// Update the hint
						$_loadMoreReviewsHint.html(_configuration.translations.reviewProgress.replace('%1', _loadedReviews).replace('%2', _configuration.reviewSummary.totalReviews));
					}
				}
			},
			complete: function()
			{
				// We are not loading anymore
				_isLoadingMoreReviews = false;

				// Disable the button and hide the loading bubbles
				$_loadMoreReviewsButton.attr('disabled', false);
				$_loadMoreReviewsButton.removeClass('xmx-button--loading');
			}
		});
    }

    /**
     * Adds freshly loaded reviews to the HTML
     */
    function addReviews(reviews)
    {
    	var review;
    	var $review;
    	var $reviewHead;
    	var $stars;
    	var $starIcon;
    	var $title;
		var $reviewBody;
		var $truncateOverlay;
		var $truncateButton;
		var $truncateButtonTitle;
		var $reviewFooter;
		var $reviewInput;
		var $truncate;
        var $description;
        var $reviewAuthor;
        var $reviewCertificate;
        var $response;
        var $responseTitle;
        var $responseBody;
        var $responseBodyDescription;

    	for (var reviewIndex in reviews)
    	{
			review = reviews[reviewIndex];

			$review = jQuery('<div>');
			$review.addClass('xmx-review');
			$review.appendTo($_reviews);

			// Build the review head
			$reviewHead = jQuery('<div>');
			$reviewHead.addClass('xmx-review-head');
			$reviewHead.appendTo($review);

			// Build the stars
			$stars = jQuery('<div>');
			$stars.addClass('xmx-rating');
			$stars.appendTo($reviewHead);

			// Add the star icons
			for (var star = 1; star <= 5; star++)
			{
				$starIcon = jQuery('<div>');

				if (review.rating >= star)
				{
					$starIcon.addClass('xmx-icon-star');
				}
				else 
				{
					if (review.rating >= star - 0.5)
					{
						$starIcon.addClass('xmx-icon-star-half');
					}
					else 
					{
						$starIcon.addClass('xmx-icon-star-empty');
					}
				}

				$starIcon.appendTo($stars);
			}

			// Build the title
            if (review.title != '')
            {
                $title = jQuery('<div>');
                $title.addClass('xmx-review-title');
                $title.attr('title', review.title);
                $title.html(review.title);
                $title.appendTo($reviewHead);
            }

            if (review.body != '')
            {
                // Build the body
                $reviewBody = jQuery('<div>');
                $reviewBody.addClass('xmx-review-body');
                $reviewBody.appendTo($review);

                $reviewInput = jQuery('<div>');
                $reviewInput.attr('type', 'checkbox');
                $reviewInput.attr('name', 'review-' + review.id);
                $reviewInput.attr('id', 'review-' + review.id);
                $reviewInput.addClass('xmx-truncate-input');

                if (review.isTruncated)
                {
                    $reviewInput.prop('checked', true);
                }

                $reviewInput.appendTo($reviewBody);

                // Truncate component
                $truncate = jQuery('<div>');
                $truncate.addClass('xmx-truncate');
                $truncate.appendTo($reviewBody);

                // Description
                $description = jQuery('<div>');
                $description.addClass('xmx-description');
                $description.html(review.body);
                $description.appendTo($truncate);

                // Add the truncation things
                $truncateOverlay = jQuery('<div>');
                $truncateOverlay.addClass('xmx-truncate-overlay');
                $truncateOverlay.appendTo($truncate);

                // Add the truncate button
                $truncateButton = jQuery('<label>');
                $truncateButton.attr('for', 'review-' + review.id);
                $truncateButton.addClass('xmx-button');
                $truncateButton.addClass('xmx-button--secondary');
                $truncateButton.appendTo($truncateOverlay);

                // Add a title to that button
                $truncateButtonTitle = jQuery('<div>');
                $truncateButtonTitle.addClass('xmx-button-label');
                $truncateButtonTitle.html(_configuration.translations.readMore);
                $truncateButtonTitle.appendTo($truncateButton);
            }

			// Add the review footer
			$reviewFooter = jQuery('<div>');
			$reviewFooter.addClass('xmx-review-foot');
			$reviewFooter.appendTo($review);

            $reviewAuthor = jQuery('<span>');
            $reviewAuthor.addClass('xmx-review-author');
            $reviewAuthor.html(_configuration.translations.reviewFooter.replace('%1', review.author).replace('%2', review.date));
            $reviewAuthor.appendTo($reviewFooter);

            if (review.isVerified)
            {
                $reviewCertificate = jQuery('<span>');
                $reviewCertificate.addClass('xmx-review-certificate');
                $reviewCertificate.addClass('xmx-icon-shield-star');
                $reviewCertificate.html(_configuration.translations.verifiedPurchase);
                $reviewCertificate.appendTo($reviewFooter);
            }

            // Response
            if (review.response)
            {
                $response = jQuery('<div>');
                $response.addClass('xmx-review-response');
                $response.appendTo($review);

                $responseTitle = jQuery('<div>');
                $responseTitle.addClass('xmx-review-title');
                $responseTitle.html(_configuration.translations.customerServiceResponse);
                $responseTitle.appendTo($response);

                $responseBody = jQuery('<div>');
                $responseBody.addClass('xmx-review-body');
                $responseBody.appendTo($response);

                $responseBodyDescription = jQuery('<div>');
                $responseBodyDescription.addClass('xmx-description');
                $responseBodyDescription.html(review['response']);
                $responseBodyDescription.appendTo($responseBody);
            }
    	}
    }

    /**
     * Updates the price UI
     */
    function updatePrice()
    {
    	var productData = _configuration.productData[_selectedProductId];
    	var $line1;
    	var $line2;
    	var $line3;
    	var $freight;
    	var $freightCaption;
    	var $oldPrice;
		var $saving;
		var $campaignBadge;
    	var $price;
		var $unitPrice;

    	// Throw away the old info
    	$_productPrice.empty();

    	// Add line 1
		$line1 = jQuery('<div>');
		$line1.addClass('xmx-product-detail-price-line-1');
		$line1.appendTo($_productPrice);

		// Add line 2
		$line2 = jQuery('<div>');
		$line2.addClass('xmx-product-detail-price-line-2');
		$line2.appendTo($_productPrice);

		// Add line 3
		$line3 = jQuery('<div>');
		$line3.addClass('xmx-product-detail-price-line-3');
		$line3.appendTo($_productPrice);

		var finalPrice = productData.finalPrice;
		var basePrice = productData.basePrice;
		var isAdwordsPrice = false;

		$_addToCartAdwordsProduct.val(0);

		if (XmxApp.isComingFromGoogleAdwords())
		{
			if (productData.adwordsPrice)
			{
				if (productData.adwordsPrice < finalPrice)
				{
					finalPrice = productData.adwordsPrice;
					isAdwordsPrice = true;
					$_addToCartAdwordsProduct.val(1); 

					// Re-calculate the base price
					// Build the base price
					if (productData.baseUnitValue > 0)
					{
						basePrice = finalPrice / productData.baseUnitValue * 100;
					}
				}
			}
		}

    	// Build line one, if there is a special price
		if (finalPrice < productData.price)
		{
			$oldPrice = jQuery('<div>');
			$oldPrice.addClass('xmx-product-detail-price-old');
			$oldPrice.html(XmxApp.formatPrice(productData.price));
			$oldPrice.appendTo($line1);

			$saving = jQuery('<div>');
			$saving.addClass('xmx-product-detail-price-saving');

			if (isAdwordsPrice)
			{
				$saving.html(productData.adwordsDiscountInfo);
			}
			else 
			{
				$saving.html(productData.discountInfo);
			}
			
			$saving.appendTo($line1);

			if (productData.campaignBadge != '')
			{
				$campaignBadge = jQuery('<div>');
				$campaignBadge.addClass('xmx-product-detail-price-badge');
				$campaignBadge.html(productData.campaignBadge);
				$campaignBadge.appendTo($line1);
			}
		}

		// Build the price
		$price = jQuery('<div>');

		if (finalPrice < productData.price)
		{
			$price.addClass('xmx-product-detail-price-special');
		}
		else 
		{
			$price.addClass('xmx-product-detail-price-regular');
		}

		$price.html(XmxApp.formatPrice(finalPrice));
		$price.appendTo($line2);

		// Build shipping
		$freight = jQuery('<div>');
		$freight.addClass('xmx-product-detail-price-freight');
		$freight.attr('id', 'product-freight');
		$freight.attr('title', _configuration.translations.readMoreAboutShipping); 
		$freight.appendTo($line2);

		// Re-hook it
		$_productFreight = $freight;
		$_productFreight.on('click', onProductFreightClick);

		// Caption the freight
		$freightCaption = jQuery('<span>');
		$freightCaption.addClass('xmx-product-detail-price-freight-inner');

		if (finalPrice >= _configuration.shipping.freeAt)
		{
			$freightCaption.html(_configuration.translations.freeShipping); 

			// Update price in shipping tab
			$_freeFreightLine.show();
			$_regularFreightLine.hide();
		}
		else 
		{
			$freightCaption.html(_configuration.translations.shipsForX.replace('%1', XmxApp.formatAmount(_configuration.shipping.fee)));

			// Update price in shipping tab
			$_freeFreightLine.hide();
			$_regularFreightLine.show();
		}

		$freightCaption.appendTo($freight);
					
		// Build the base price
		if (basePrice > 0)
		{
			$unitPrice = jQuery('<div>');
			$unitPrice.addClass('xmx-price-unit');

			if (productData.baseUnitValue == 1)
			{
				$unitPrice.html(XmxApp.formatAmount(basePrice) + ' / ' + productData.baseUnitMeasure);
			}
			else 
			{
				$unitPrice.html(XmxApp.formatAmount(basePrice) + ' / ' + XmxApp.formatUnit(productData.baseUnitValue, productData.baseUnitMeasure));
			}

			$unitPrice.appendTo($line3);
		}

		// Add the Klarna Delbetalning info, if present
		if (productData.klarnaPayment)
		{
			var $klarnaPaymentHint = jQuery('<div>');
			$klarnaPaymentHint.addClass('xmx-payment-hint');

			var $klarnaLogo = jQuery('<img>');
			$klarnaLogo.addClass('xmx-payment-hint-logo');
			$klarnaLogo.attr('src', '/static/expresscheckout/logo-klarna.svg');
			$klarnaLogo.attr('height', 20);
			$klarnaLogo.attr('width', 56);
			$klarnaLogo.attr('alt', 'Klarna');
			$klarnaLogo.appendTo($klarnaPaymentHint);

			var $klarnaLabel = jQuery('<div>');
			$klarnaLabel.addClass('xmx-payment-hint-label');
			$klarnaLabel.html('Delbetala från ' + XmxApp.formatAmount(productData.klarnaPayment.monthlyPayment) + ' i ' + productData.klarnaPayment.months + ' månader');
			$klarnaLabel.appendTo($klarnaPaymentHint);

			$klarnaPaymentHint.appendTo($_productPrice);
		}
    }

    /**
     * A slide has changed
     */
    function onSwiperSlideChange()
    {
    	// This fires on initialization as well, but our member is not set yet
    	if (_swiper == null)
    	{
    		return;
    	}

    	// Unselect all thumbnails
    	jQuery('> div', $_thumbnails).removeClass('xmx-product-image-thumbnail--selected');

    	// Select the current one
    	jQuery('> div[data-media-index="' + _swiper.realIndex + '"]', $_thumbnails).addClass('xmx-product-image-thumbnail--selected');
    }

    /**
     * User has clicked on a the large display image
     */
    function onSwiperSlideClick(event)
    {
        // If this is not the left mouse button, get out of here.
        // Mouse button 3 or any mouse back buttons are not functional
        // otherwise.
        if (typeof(event.button) !== 'undefined')
        {
            if (event.button != 0)
            {
                return false;
            }
        }

		jQuery.fancybox.open
		(
		    _fancyBoxSlides,
		    _fancyBoxOptions,
		    _swiper.realIndex
		);

        event.stopPropagation();

        return false;
    }

    /**
     * If there is no swiper, open the image directly when the user clicked on it
     */
    function onMainImageClick()
    {
		jQuery.fancybox.open
		(
		    _fancyBoxSlides,
		    _fancyBoxOptions,
		    0
		);
    }

    /**
     * A user has a clicked on an image thumbnail
     */
    function onThumbnailClick()
    {
    	var $thumbnail = jQuery(this);
    	var mediaIndex = $thumbnail.data('media-index');

		_swiper.slideToLoop(mediaIndex);
    }

    /**
     * Updates the gallery UI
     */
    function updateGallery()
    {
    	var productData = _configuration.productData[_selectedProductId];
    	var imageData;
        var lastImage;
    	var $thumbnail;
    	var $thumbnailImage;
        var $thumbnailPicture;
        var $mobileThumbnailSource;
        var $desktopThumbnailSource;
    	var mediaIndex = 0;
    	var totalNumberOfSlides = 0;
        var $swiperContainer;
        var $swiperButtonNext;
        var $swiperButtonPrevious;
        var $swiperWrapper;
        var $swiperSlide;
        var $videoTitle;
        var $videoIcon;
        var $swiperImage;
        var $swiperPicture;
        var $swiperImageSource;
        var galleryImage;

    	// If there is a swiper, kill it
    	if (_swiper != null)
    	{
    		_swiper.destroy();
    		_swiper = null;
    	}

    	// Rebuild the thumbnails and display images
    	$_thumbnails.empty();
    	$_mainImage.empty();

    	// Rebuild the Fancy Box slides
    	_fancyBoxSlides = [];

    	// Add a swiper container to the main image
        $swiperContainer = jQuery('<div>');
        $swiperContainer.addClass('xmx-swiper-container');
        $swiperContainer.attr('id', 'display-swiper-container');
        $swiperContainer.appendTo($_mainImage);

		// Arrow right
		$swiperButtonNext = jQuery('<button>');
		$swiperButtonNext.addClass('xmx-swiper-button');
		$swiperButtonNext.addClass('xmx-swiper-button--next'); 
		$swiperButtonNext.attr('id', 'display-swiper-button-next');
        $swiperButtonNext.attr('type', 'button');
		$swiperButtonNext.appendTo($_mainImage);

		// Arrow left
		$swiperButtonPrevious = jQuery('<button>');
		$swiperButtonPrevious.addClass('xmx-swiper-button');
		$swiperButtonPrevious.addClass('xmx-swiper-button--previous');
		$swiperButtonPrevious.attr('type', 'button');
		$swiperButtonPrevious.attr('id', 'display-swiper-button-prev');
		$swiperButtonPrevious.appendTo($_mainImage);

        // Add a swiper wrappper to the main image swiper container
        $swiperWrapper = jQuery('<div>');
        $swiperWrapper.addClass('xmx-swiper-elements');
        $swiperWrapper.appendTo($swiperContainer);

    	// Add the images
		for (var imageIndex in productData.images)
		{
			imageData = productData.images[imageIndex];

			// Create the thumbnail
			$thumbnail = jQuery('<div>');
			$thumbnail.addClass('xmx-product-image-thumbnail');
			$thumbnail.attr('data-media-index', mediaIndex);

			if (imageIndex == 0)
			{
				$thumbnail.addClass('xmx-product-image-thumbnail--selected');
			}

			$thumbnail.on('click', onThumbnailClick);
			$thumbnail.appendTo($_thumbnails);

            // Responsive thumbnail image
            $thumbnailPicture = jQuery('<picture>');

            $mobileThumbnailSource = jQuery('<source>');
            $mobileThumbnailSource.attr('media', '(max-width: 1279px)');
            $mobileThumbnailSource.attr('srcset', imageData.mobileThumbnailUrl);
            $mobileThumbnailSource.appendTo($thumbnailPicture);

            $desktopThumbnailSource = jQuery('<source>');
            $desktopThumbnailSource.attr('media', '(min-width: 1280px)');
            $desktopThumbnailSource.attr('srcset', imageData.desktopThumbnailUrl);
            $desktopThumbnailSource.appendTo($thumbnailPicture);

			// Add the image to the thumbnail
			$thumbnailImage = jQuery('<img>');
			$thumbnailImage.addClass('xmx-product-image-thumbnail-image');
			$thumbnailImage.attr('src', imageData.desktopThumbnailUrl);
			$thumbnailImage.attr('width', 36);
			$thumbnailImage.attr('height', 36);
			$thumbnailImage.attr('alt', imageData.label);
			$thumbnailImage.appendTo($thumbnailPicture);

            $thumbnailPicture.appendTo($thumbnail);


			// Create a large slide
            $swiperSlide = jQuery('<div>');
            $swiperSlide.addClass('xmx-swiper-element');
            $swiperSlide.appendTo($swiperWrapper);

            lastImage = null;
            $swiperPicture = jQuery('<picture>');

            for (var galleryIndex in imageData.gallery)
            {
                galleryImage = imageData.gallery[galleryIndex];
                lastImage = galleryImage;

                $swiperImageSource = jQuery('<source>');
                $swiperImageSource.attr('media', galleryImage.media);
                $swiperImageSource.attr('srcset', galleryImage.src);
                $swiperImageSource.appendTo($swiperPicture);
            }

            if (lastImage)
            {
                // Add the image to the slide
                $swiperImage = jQuery('<img>');
                $swiperImage.addClass('xmx-product-main-image-image');
                $swiperImage.attr('alt', imageData.label);
                $swiperImage.attr('src', lastImage.src);
                $swiperImage.attr('width', 600);
                $swiperImage.attr('height', 600);
                $swiperImage.appendTo($swiperPicture);
            }

            $swiperPicture.appendTo($swiperSlide);

            // Count the slide
            totalNumberOfSlides++;
            mediaIndex++;

			// Add a fancy box slide
			_fancyBoxSlides.push
			({
			    src: imageData.zoomImageUrl,
			    type: 'image',
			    opts: {}
			});
		}

		// Remove all image count classes
		$_imageGallery.removeClass(function(index, className)
		{
			return (className.match (/(^|\s)xmx-product-image-gallery--\d+/g) || []).join(' ');
		});


    	// Add a YouTube video, if there is one
        if (productData.videoUrl != '')
        {
        	// Create a video thumbnail
			$thumbnail = jQuery('<div>');
			$thumbnail.addClass('xmx-product-image-thumbnail');
			$thumbnail.addClass('xmx-product-image-thumbnail--video');
			$thumbnail.addClass('xmx-icon-play');
			$thumbnail.attr('data-media-index', mediaIndex);
			$thumbnail.on('click', onThumbnailClick);
			$thumbnail.appendTo($_thumbnails);

			$videoTitle = jQuery('<span>');
			$videoTitle.addClass('xmx-product-image-thumbnail-title');
			$videoTitle.html(_configuration.translations.video);
			$videoTitle.appendTo($thumbnail);

			// Create a large slide
            $swiperSlide = jQuery('<div>');
            $swiperSlide.addClass('xmx-swiper-element');
            $swiperSlide.appendTo($swiperWrapper);

            // Add the main image to the slide
            imageData = productData.images[0];

            lastImage = null;
            $swiperPicture = jQuery('<picture>');

            for (var galleryIndexB in imageData.gallery)
            {
                galleryImage = imageData.gallery[galleryIndexB];
                lastImage = galleryImage;

                $swiperImageSource = jQuery('<source>');
                $swiperImageSource.attr('media', galleryImage.media);
                $swiperImageSource.attr('srcset', galleryImage.src);
                $swiperImageSource.appendTo($swiperPicture);
            }

            if (lastImage)
            {
                // Add the image to the slide
                $swiperImage = jQuery('<img>');
                $swiperImage.addClass('xmx-product-main-image-image');
                $swiperImage.attr('alt', imageData.label);
                $swiperImage.attr('src', lastImage.src);
                $swiperImage.attr('width', 600);
                $swiperImage.attr('height', 600);
                $swiperImage.appendTo($swiperPicture);
            }

            $swiperPicture.appendTo($swiperSlide);

            $videoIcon = jQuery('<div>');
            $videoIcon.addClass('xmx-swiper-video-icon');
            $videoIcon.addClass('xmx-icon-play-white');
            $videoIcon.appendTo($swiperSlide);

            // Count the slide
            totalNumberOfSlides++;
            mediaIndex++;

        	// Add the video to the Fancy Box
            _fancyBoxSlides.push
            ({
                src: productData.videoUrl,
                opts: {}
            });
        }

        $_imageGallery.addClass('xmx-product-image-gallery--' + totalNumberOfSlides);

        // Create a swiper object, but only if there are more than one image
        if (totalNumberOfSlides > 1)
        {
	        _swiper = new Swiper('#display-swiper-container', 
	        {
                containerModifierClass: 'xmx-swiper-container--',
                wrapperClass: 'xmx-swiper-elements',
                slideClass: 'xmx-swiper-element',
                slideActiveClass: 'xmx-swiper-element--active',
                slideVisibleClass: 'xmx-swiper-element--visible',
                slidePrevClass: 'xmx-swiper-element--previous',
                slideNextClass: 'xmx-swiper-element--next',
	            centeredSlides: true,
	            spaceBetween: 24,
	            loopedSlides: totalNumberOfSlides,
	            preventClicksPropagation: true,
	            loop: true,
	            simulateTouch: true,
	            threshold: 0,
	            grabCursor: false,
                navigation:
                {
					nextEl: '#display-swiper-button-next',
					prevEl: '#display-swiper-button-prev',
                    disabledClass: 'xmx-swiper-button--disabled'
                },
	            on: 
	            {
	            	slideChange: onSwiperSlideChange,
	            	click: onSwiperSlideClick
	            }
	        });
        }
        else 
        {
	        jQuery('img', $_mainImage).on('click', onMainImageClick);
        }
    }

    /**
     * Updates the stock UI
     */
    function updateStockInformation()
    {
    	if (_configuration.productData[_selectedProductId].stockColor == 'red')
    	{
    		$_productStock.addClass('xmx-stock--critical');
		}
		else 
		{
			$_productStock.removeClass('xmx-stock--critical');
		}

		$_productStock.html(_configuration.productData[_selectedProductId].stockLabel);

		if (_configuration.productData[_selectedProductId].isInStock)
		{
    		// Show the add to cart button
			$_addToCartArea.show();

			// Hide the "Email me when its back area"
			$_outOfStockReminder.hide();
		}
		else 
		{
    		// Hide the add to cart button
			$_addToCartArea.hide();

			// Show the "Email me when its back area"
			$_outOfStockReminder.show();
    	}
    }

    /**
     * Changes to a given product ID
     */
    function changeSelectedProduct(productId)
    {
    	// Do not change twice
    	if (productId == _selectedProductId)
    	{
    		return;
    	}

    	_selectedProductId = productId;

    	// Update the form field
    	$_addToCartFormProduct.val(_selectedProductId);

    	// Update all the things
    	updateGallery();
    	updatePrice();
		updateStockInformation();
		updateFlashSaleHint();
    }

    /**
     * The user has clicked on a variant
     */
    function onVariantClick(event)
    {
    	var $variant = jQuery(this);
    	var productId = $variant.data('product-id');
    	var variantData;

    	// Select the variant
    	$_variants.removeClass('xmx-product-variation--selected');
    	$variant.addClass('xmx-product-variation--selected');

    	// Change the name
    	for (var variantIndex in _configuration.variants)
    	{
    		variantData = _configuration.variants[variantIndex];

    		if (variantData.productId == productId)
    		{
    			$_selectedVariantName.html(variantData.optionLabel);
    			break;
    		}
    	}

    	// Change to that variant
    	changeSelectedProduct(productId);

        // Prevent following this link
        event.preventDefault();
    }

    /**
     * The user has clicked on the star rating at the top
     */
    function onProductRatingClick()
    {
    	var $content = $_accordionReviewsInput.next();
    	var scrollOffset = _isDesktop ? 120 : 48;

    	$_accordionReviewsInput.prop('checked', true);

    	jQuery('html,body').animate({scrollTop: $content.offset().top - scrollOffset}, 'slow');
    }

    /**
     * The user has clicked on the freight next to the price
     */
    function onProductFreightClick()
    {
    	var $content = $_accordionShippingInput.next();
    	var scrollOffset = _isDesktop ? 120 : 48;

    	$_accordionShippingInput.prop('checked', true);

    	jQuery('html,body').animate({scrollTop: $content.offset().top - scrollOffset}, 'slow');
    }

    /**
     * The user has clicked on a "write review" button
     */
    function onWriteReviewButtonClick()
    {
    	$_writeReviewCallout.hide();
    	$_writeReviewArea.show();
    }
    
    /**
    * Public interface
    */
    return { // line break is not allowed here

        /**
         * Constructor, boots the checkout
         */
        construct: function() 
        {
            boot();
        },
    };
})();

// Boot the mobile menu
mshopProductPage.construct();
